export default __webpack_public_path__ + "static/media/final.e19456ca.mp3";